import {TestItem,Pagination} from "features/model/types/lessons/lessons-test/lessonsTest";
import {createSlice, PayloadAction} from "@reduxjs/toolkit";


interface LessonsDemoState {
    items: TestItem[];
    pagination: Pagination;
    isLoading: boolean;
    error: string | null;

}


const initialState: LessonsDemoState = {
    items: [],
    isLoading: true,
    pagination: {} as Pagination,
    error: null,
};

const lessonsTestSlice = createSlice({
    name: "lessons/test",
    initialState,
    reducers: {
        setLessonsTest: (state, action) => {
            const {items} = action.payload;
            state.items = items;
            state.isLoading = false;
            state.error = null;
        },
        setLoadingLessonsTest: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
        },
        setErrorLessonsTest: (state, action) => {
            state.error = action.payload;
        },

    },

});


export const {
    setLessonsTest,
    setLoadingLessonsTest,
    setErrorLessonsTest
} = lessonsTestSlice.actions;
export const lessonsTestReducer = lessonsTestSlice.reducer;


